import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'
import * as Yup from 'yup'
import { Modal } from 'react-bootstrap'
import { defaultChannelEnrollment, ISCEnrollmentData } from './InterfaceSalesChannelModal'
import { StepperComponent } from '../../../../_metronic/assets/ts/components'
import { checkUploadStatus, toaster, alert } from '../../../../utils/helper'
import closeSymbol from '../../../../_metronic/images/closeSymbol.svg'
import {
  CREATE_AGENTS,
  CREATE_SALES_CHANNEL,
  UPLOAD_AGENTS,
  VALIDATE_USER,
  GET_CLIENT_ALLOWED_COMPONENTS,
  CREATE_AGENTS_WITH_USERID_PASSWORD,
  UPLOAD_AGENTS_USERID_PASSWORD
} from '../../../../utils/GraphQLAPI'
import { KTSVG } from '../../../../_metronic/helpers'
import { SalesChannelInfo } from './steps/SalesChannelInfo'
import { ProductInfo } from './steps/ProductInfo'
import { useFormik, FormikProvider } from 'formik'
import Arrow from '../../../../_metronic/images/arr002.svg'
import SVG from 'react-inlinesvg'
import { useLazyQuery, useMutation } from '@apollo/client'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './sc.css'
import { AgentInfo } from './steps/AgentInfo'
import Settings from './steps/Settings'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
import AgentLeader from './steps/AgentLeader'
import { createAgentHelper } from './SalesChannelHelpers'
const MySwal = withReactContent(Swal)

type Props = {
  show: boolean
  handleClose: () => void
  refetchList: () => void
  method: string
  editId: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const CreateSalesChannelModal = ({ show, handleClose, refetchList, method, editId }: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [data, setData] = useState<any>(defaultChannelEnrollment)
  const [hasError, setHasError] = useState(false)
  const [hasFieldError, setHasFieldError] = useState(false)
  const [generateTrackId, setGenerateTrackId] = useState<any>()
  const [isSparks, setIsSparks] = useState<any>(false)
  const [isSolarProduct, setIsSolarPRoduct] = useState<any>(false)
  const [activeStatus, setActiveStatus] = useState<boolean>(false)
  const [isUploadMode, setIsUploadMode] = useState(false)

  // Email validation
  const [validEmail, setValidEmail] = useState<boolean>(true)
  const [salesAdmin, setSalesAdmin] = useState<string>()

  // required fields for Customer Enrollment

  const agentSchema = Yup.array().of(
    Yup.object().shape({
      agentEmailID: Yup.string()
        .email('Invalid Email')
        .required('Email ID is required')
        .notOneOf([salesAdmin], 'Email cannot be same as admin'),
      agentFirstName: Yup.string().required('First Name is required'),
      agentLastName: Yup.string().required('Last Name is require'),
    })
  )

  const agentUserNamePasswordSchema = Yup.array().of(
    Yup.object().shape({
      agentFirstName: Yup.string().required('First Name is required'),
      agentLastName: Yup.string().required('Last Name is require'),
      UserName: Yup.string()
        .required('User ID is required')
        .min(7, 'Minimum 7 characters are required')
        .matches(
         /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{7,}$/,
          'Username must contain at least 7 characters, including one uppercase letter, one lowercase letter, and one number. (Example: TpvSolutions123)'
        ),
      agentPassword: Yup.string()
        .min(8, 'Minimum 8 characters are required')
        .max(15, 'Maximum 15 characters are allowed')
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d`~!@#$%^&*()_+=\-{}|[\]:;"'<>,.?\/]{8,}$/,
          'Password must be at least 8 characters, include uppercase, lowercase, number, and symbol (Example:TpvSolutions@123)'
        ).required('Password is required'),
    })
  )

  const enrollSchema = Yup.object().shape({
    salesChannelName: Yup.string()
      .required('Channel name is required')
      .trim()
      .min(3, "Channel name shouldn't be less than 3 characters")
      .max(40, 'Channel name should not exceed 40 characters'),
    salesChannelAdminFirstName: Yup.string()
      .required('Admin first name is required')
      .trim()
      .matches(/^[0-9a-zA-Z \b]+$/, GLOBAL_CONSTANTS.specialCharactersNotAllowed)
      .max(40, 'Admin first name should not exceed 40 characters'),
    salesChannelAdminLastName: Yup.string()
      .required('Admin last name is required')
      .trim()
      .matches(/^[0-9a-zA-Z \b]+$/, GLOBAL_CONSTANTS.specialCharactersNotAllowed)
      .max(40, 'Admin last name should not exceed 40 characters'),
    salesChannelAdminEmail: Yup.string()
      .required('Email ID is required')
      .trim()
      .email('Enter a valid email id'),
    // Validation for email when we add the products
    agentLeaders: Yup.array().of(
      Yup.object().shape({
        leaderName: Yup.string().required('Agent Leader Name is required'),
        leaderCode: Yup.string().required('Agent Leader Code is required'),
      })
    ),
    agent: activeStatus ? agentSchema : agentUserNamePasswordSchema,
  })
  useEffect(() => {
    if (method === 'create') {
      setHasError(false)
      formik.setValues({ ...defaultChannelEnrollment })
    }

    formik.resetForm()

    setHasFieldError(false)
  }, [show, editId])

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }
  //helper function to update the state
  const updateData = (fieldsToUpdate: Partial<ISCEnrollmentData>) => {
    const updatedData = { ...data, ...fieldsToUpdate }
    setData(updatedData)
  }
  const handlePrevStep = () => {

    if (!stepper.current) {
      return
    }
    stepper.current.goPrev()
  }
  //fn to handle next
  const handleNextStep = () => {

    setHasError(false)

    if (!stepper.current) {
      return
    }
    if (stepper.current.getCurrentStepIndex() === 1) {
      if (
        formik.errors.salesChannelName ||
        formik.errors.salesChannelAdminFirstName ||
        formik.errors.salesChannelAdminLastName ||
        formik.errors.salesChannelAdminEmail
      ) {
        setHasFieldError(true)
        setHasError(true)
        return
      }
    } else if (stepper.current.getCurrentStepIndex() === 2 && formik.errors.utility) {
      setHasFieldError(true)
      setHasError(true)
      return
    } else if (
      stepper.current.getCurrentStepIndex() === 3 &&
      formik.errors.agentLeaders &&
      formik.values.agentLeaders.length > 0
    ) {
      setHasFieldError(true)
      setHasError(true)
      if (Array.isArray(formik.errors.agentLeaders)) {
        formik.errors.agentLeaders.forEach((_, index) => {
          formik.setFieldTouched(`agentLeaders[${index}].leaderCode`, true)
          formik.setFieldTouched(`agentLeaders[${index}].leaderName`, true)
        })
      } else {
        formik.setFieldTouched('agentLeaders', true)
      }
      return
    } else if (stepper.current.getCurrentStepIndex() === 4) {
      if (!isUploadMode && Object.keys(formik.errors).length > 0) {
        formik.setFieldTouched(`agent`, true)
        setHasError(true)
        return
      }
    } else if (stepper.current.getCurrentStepIndex() === 5 && formik.errors) {
      setHasError(true)

      return
    }
    if (validEmail) {
      stepper.current.goNext()
    }
  }

  const formik = useFormik({
    initialValues: defaultChannelEnrollment,
    validationSchema: enrollSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      if (validEmail) {
        createSalesChannel({
          variables: {
            createSalesChannelInput: {
              name: values.salesChannelName,
              salesAdmin: {
                salesAdminFirstName: values.salesChannelAdminFirstName,
                salesAdminLastName: values.salesChannelAdminLastName,
                salesAdminEmailId: values.salesChannelAdminEmail,
              },
              repId: values.repId,
              salesChannelProductIds: values.productIds,
              enableIvr: values.ivr,
              enableLiveAgent: values.liveAgent,
              enableNoTPV: values.enableNoTPV,
              enableTelephoneViewForSalesAdmin: values.enableTelephoneViewForSalesAdmin,
              enableTextTpv: values.textTpv,
              enableSmsDocumentVerification: values.smsD2D,
              enableEmailDocumentVerification: values.emailD2D,
              enableOutBoundLiveAgent: values.outboundLiveAgent,
              enableContractRequired: values?.enableContractRequired,
              channelType: values?.salesChannelType,
              enableCustomerBillImage: values?.enableCustomerBillImage,
              enableMultipleUan: values?.enableMultipleUan,
              agentLeaderInputs: formik.values.agentLeaders.map((leader: any) => ({
                ...leader,
                leaderStatus: true,
              })),
            },
          },
        })
      }
    },
  })
  useEffect(() => {
    setSalesAdmin(formik.values.salesChannelAdminEmail)
  }, [formik.values.salesChannelAdminEmail])

  const [createSalesChannel, { loading }] = useMutation(CREATE_SALES_CHANNEL, {
    onCompleted: (salesChanneldata) => {
      const agentValue: any = formik.getFieldMeta('agent').value
      if (agentValue.length > 0) {
        console.log('createsaleschannelmodule')
        createAgentHelper(
          agentValue,
          salesChanneldata?.createSalesChannel?.agentLeader,
          setGenerateTrackId,
          createAgents,
          uploadAgent,
          salesChanneldata.createSalesChannel.id,
          createAgentsUsingUserIdAndPassword,
          activeStatus,
          uploadAgentUserPassword
        )
      }

      if (salesChanneldata.createSalesChannel.id) {
        const options: any = {
          customClass: {
            popup: 'swal2-border-radius',
          },
          title: 'Sales Channel created successfully',
          icon: 'success',
          confirmButtonColor: '#3E97FF',
        }
        MySwal.fire(options)
        formik.setValues({ ...defaultChannelEnrollment })
        handleClose()
      }
    },
    onError: (error) => {
      MySwal.fire({
        icon: 'error',
        title: error.message,
      })
    },
  })

  const [getClientAllowedComponents] = useLazyQuery(GET_CLIENT_ALLOWED_COMPONENTS, {
    onCompleted: (data) => {
      setIsSparks(data?.getClientAllowedComponents.includes('customerBillImageToSalesChannel'))
      setIsSolarPRoduct(data?.getClientAllowedComponents.includes('solarProductSetup'))
    },
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
  })
  useEffect(() => {
    getClientAllowedComponents()
  }, [])

  const successMessage = 'Agent created successfully'
  const [uploadAgent] = useMutation(UPLOAD_AGENTS, {
    onCompleted: (data) => {
      if (data.uploadAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.uploadAgents, 'warning')
      } else if (data.uploadAgents.includes(successMessage)) {
        toaster(data.uploadAgents, 'success')
      } else if (data.uploadAgents.includes(generateTrackId)) {
        toaster(successMessage, 'success')
      }
      else {
        toaster(data.uploadAgents, 'error')
        return  // This line was added to handle the case where the uploadAgents response does not match expected values  
      }
      checkUploadStatus(generateTrackId, refetchList)
      handleClose()
    },
    onError: (error) => {
      alert(error.message, 'error')
      handleClose()
    },
  })
  const [uploadAgentUserPassword] = useMutation(UPLOAD_AGENTS_USERID_PASSWORD, {
    onCompleted: (data) => {
      if (data.uploadAgentsUserNameFlow.includes('got failed while creating, Email has been sent')) {
        toaster(data.uploadAgentsUserNameFlow, 'warning')
      } else if (data.uploadAgentsUserNameFlow.includes(successMessage)) {
        toaster(data.uploadAgentsUserNameFlow, 'success')
      } else if (data.uploadAgentsUserNameFlow.includes(generateTrackId)) {
        toaster(successMessage, 'success')
      }
      else {
        toaster(data.uploadAgentsUserNameFlow, 'error')
        return  // This line was added to handle the case where the uploadAgents response does not match expected values  
      }
      checkUploadStatus(generateTrackId, refetchList)
      handleClose()
    },
    onError: (error) => {
      alert(error.message, 'error')
      handleClose()
    },
  })

  const [createAgents] = useMutation(CREATE_AGENTS, {
    onCompleted: async (data) => {
      if (data.createAgents.includes('got failed while creating, Email has been sent')) {
        toaster(data.createAgents, 'warning')
      } else if (data.createAgents.includes('Agent created successfully')) {
        toaster(data.createAgents, 'success')
      } else {
        toaster(data.createAgents, 'error')
      }
      handleClose()
      refetchList()
      formik.setValues({ ...defaultChannelEnrollment })
    },
    onError: (error) => toaster(error.message, 'error'),
  })
  const [createAgentsUsingUserIdAndPassword] = useMutation(CREATE_AGENTS_WITH_USERID_PASSWORD, {
    onCompleted: async (data) => {
      if (data.CreateAgentsUserNameFlow.includes('got failed while creating, Email has been sent')) {
        toaster(data.CreateAgentsUserNameFlow, 'warning')
      } else if (data.CreateAgentsUserNameFlow.includes('Agent created successfully')) {
        toaster(data.CreateAgentsUserNameFlow, 'success')
      } else {
        toaster(data.CreateAgentsUserNameFlow, 'error')
      }
      handleClose()
      refetchList()
      formik.setValues({ ...defaultChannelEnrollment })
    },
    onError: (error) => toaster(error.message, 'error'),
  })

  // API to verify email id already exists in db or not.
  const [emailValidation] = useLazyQuery(VALIDATE_USER, {
    fetchPolicy: GLOBAL_CONSTANTS.networkOnly,
    onCompleted: (emailData) => {
      if (
        emailData.validateUser.users[0].emailId !== '' &&
        emailData.validateUser.users[0].type === 'EXISTS'
      ) {
        setValidEmail(false)
      } else {
        setValidEmail(true)
      }
    },
  })

  // to verify entered email id already exists in db or not.
  const handleEmailValidation = (objValue: any) => {
    if (objValue.length > 0 && /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(objValue)) {
      emailValidation({
        variables: {
          validateUserInput: {
            users: [
              {
                emailId: objValue,
              },
            ],
          },
        },
      })
    }
  }

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-fullscreen'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header'>
        <h2>Add Sales Channel</h2>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <SVG src={closeSymbol}></SVG>
        </div>
      </div>

      <div className='modal-body py-lg-10 px-lg-10 d-flex flex-column flex-row-fluid'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-xs-column flex-row flex-xl-row flex-row-fluid h-100'
          id='kt_modal_create_app_stepper'
        >
          <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-300px h-100'>
            <div className='stepper-nav ps-lg-10' style={{ gap: "100px" }}>
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper w-30'>
                  <div className='stepper-icon w-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>

                  <div className='stepper-label'>
                    <span
                      className='stepper-title fw-500'
                      style={{
                        color: '#5E6278',
                        fontSize: '15px',
                        fontStyle: 'normal',
                        lineHeight: '24px',
                      }}
                    >
                      Sales Channel Info
                    </span>

                    <div
                      className='stepper-desc text-muted'
                      style={{ fontSize: '12px', lineHeight: '18px' }}
                    >
                      Provide channel information
                    </div>
                  </div>
                </div>

              </div>

              <div className='stepper-item' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>

                  <div className='stepper-label'>
                    <span
                      className='stepper-title fw-500'
                      style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                    >
                      Product Info
                    </span>

                    <div
                      className='stepper-desc text-muted'
                      style={{ fontSize: '12px', lineHeight: '18px' }}
                    >
                      Assign products
                    </div>
                  </div>
                </div>

              </div>
              <div className='stepper-item' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>

                  <div className='stepper-label'>
                    <span
                      className='stepper-title fw-500'
                      style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                    >
                      Agent Leaders
                    </span>

                    <div
                      className='stepper-desc text-muted'
                      style={{ fontSize: '12px', lineHeight: '18px' }}
                    >
                      Create Agent Leaders
                    </div>
                  </div>
                </div>

              </div>
              <div className='stepper-item' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>4</span>
                  </div>

                  <div className='stepper-label'>
                    <span
                      className='stepper-title fw-500'
                      style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                    >
                      Agent Info
                    </span>

                    <div
                      className='stepper-desc text-muted'
                      style={{ fontSize: '12px', lineHeight: '18px' }}
                    >
                      Add agent list
                    </div>
                  </div>
                </div>
              </div>

              <div className='stepper-item' data-kt-stepper-element='nav'>
                <div className='stepper-wrapper'>
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>5</span>
                  </div>

                  <div className='stepper-label'>
                    <span
                      className='stepper-title fw-500'
                      style={{ color: '#5E6278', fontSize: '15px', lineHeight: '24px' }}
                    >
                      Settings
                    </span>

                    <div
                      className='stepper-desc text-muted'
                      style={{ fontSize: '12px', lineHeight: '18px' }}
                    >
                      Enable/Disable Features
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='flex-row-fluid px-lg-2 w-500px h-100 overflow-auto'>
            <FormikProvider value={formik}>
              <form
                noValidate
                id='kt_modal_create_app_form'
                onSubmit={(e) => {
                  e.preventDefault()
                  formik.handleSubmit()
                }}
              >
                <SalesChannelInfo
                  isSparks={isSparks}
                  data={data}
                  formik={formik}
                  updateData={updateData}
                  hasError={hasError}
                  hasFieldError={hasFieldError}
                  method={method}
                  handleClose={handleClose}
                  validEmail={validEmail}
                  handleEmailValidation={handleEmailValidation}
                  isSolarProduct={isSolarProduct}
                />
                <ProductInfo
                  data={data}
                  formik={formik}
                  updateData={updateData}
                  hasError={hasError}
                  hasFieldError={hasFieldError}
                  method={method}
                  validEmail={validEmail}
                  handleEmailValidation={handleEmailValidation}
                />
                <div
                  className={'pb-5'}
                  style={{ overflowY: 'auto', flex: 1 }}
                  data-kt-stepper-element='content'
                >
                  <AgentLeader formik={formik} />
                </div>
                <AgentInfo
                  data={data}
                  formik={formik}
                  updateData={updateData}
                  hasError={hasError}
                  hasFieldError={hasFieldError}
                  method={method}
                  validEmail={validEmail}
                  handleEmailValidation={handleEmailValidation}
                  setActiveStatus={setActiveStatus}
                  activeStatus={activeStatus}
                  isUploadMode={isUploadMode}
                  setIsUploadMode={setIsUploadMode}

                />
                <Settings formik={formik} isEdit={false} isSparks={isSparks} isScroll={true} />
                {/*begin::Actions */}
                <div className='d-flex flex-stack pt-10'>
                  <div className='me-2'>
                    <button
                      type='button'
                      className='btn btn-lg btn-light-primary me-3'
                      data-kt-stepper-action='previous'
                      onClick={handlePrevStep}
                    >
                      <span className='me-1'>
                        <SVG src={Arrow} className='mh-50px' />
                      </span>
                      <span>Back</span>
                    </button>
                  </div>
                  <div>
                    <button
                      type='submit'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='submit'
                      disabled={loading}
                    >
                      {loading && (
                        <span
                          className="spinner-border spinner-border-sm text-white"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      {loading ? " Submiting..." : "Submit"}
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-2 me-0'
                      />
                    </button>

                    <button
                      type='button'
                      className='btn btn-lg btn-primary'
                      data-kt-stepper-action='next'
                      onClick={handleNextStep}
                    >
                      Continue
                      <KTSVG
                        path='/media/icons/duotune/arrows/arr064.svg'
                        className='svg-icon-3 ms-1 me-0'
                      />
                    </button>
                  </div>
                </div>
              </form>
            </FormikProvider>
          </div>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export { CreateSalesChannelModal }
